import React from 'react'

function Loader() {
    return (
        <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", background: "linear-gradient(303.64deg, #d2f5ff 11.49%, #62d6ff 65.39%)" }}>
            <div className="loader-3">
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
            </div>
        </div>
    )
}

export default Loader;